import React, {useCallback} from "react";
import {FileRead} from "../../../../declarations";
import {downloadFileVariables, InputUtils} from "../../../../helpers";
import {Colors, Container, IconAttachment, IconDocument, Text} from "../../../../ui";
import {FileTypeMap} from "../../../constants";
import {useIsMobile} from "../../../helpers";

interface IDocumentDetails {
  file: FileRead;
  accountId?: string;
  downloadUserFiles: (variables: downloadFileVariables) => Promise<void | string>;
  isAttachment?: boolean;
  isTable?: boolean;
}

export const DocumentDetails = ({
  file,
  accountId,
  downloadUserFiles,
  isAttachment,
  isTable,
}: IDocumentDetails) => {
  const isMobile = useIsMobile();
  const truncate = !InputUtils.containsHyphenOrSpace(file.filename);

  const handleClick = useCallback(() => {
    downloadUserFiles({
      accountId,
      fileId: file.id,
      isMobile,
      viewMode: true,
      fileName: file.filename,
    });
  }, [accountId, file.id, file.filename, isMobile, downloadUserFiles]);

  return (
    <Container fullWidth row sx={{alignItems: "center"}}>
      {isAttachment ? <IconAttachment /> : <IconDocument />}
      <Container
        onClick={handleClick}
        sx={{alignItems: "start", gap: "0px", flexDirection: isAttachment ? "row" : "column"}}
      >
        <Text
          size={14}
          variant={"inter600"}
          sx={{
            whiteSpace: "break-spaces",
            cursor: "pointer",
            ...(isTable && {textDecoration: "underline", color: Colors.primary._700}),
            ...(truncate && isMobile && {width: "250px", overflow: "hidden", textOverflow: "ellipsis"}),
          }}
        >
          {file.filename}{" "}
        </Text>
        {!isTable && (
          <Container row sx={{alignItems: "start"}}>
            <Text size={14}>{FileTypeMap.get(file.type)?.labelKey}</Text>
            <Text
              size={14}
              fontWeight={"bold"}
              sx={{
                display: "inline",
                cursor: "pointer",
                color: Colors.primary._700,
              }}
            >
              View
            </Text>
          </Container>
        )}
      </Container>
    </Container>
  );
};
